import {FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE, SET_FAV_ICON, SET_LOGO} from '../../constants/ActionTypes'
import {TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH,IS_PASSWORD_CHANGE} from "../../constants/ActionTypes";
import { TAB_SIZE } from "../../constants/ThemeSetting";

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  navCollapsed: false, // Start with sidebar closed
  width: window.innerWidth,
  pathname: '/',
  favicon : '', 
  logo : '',
  isPassword:false
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      return {
        ...state,
        pathname: action.payload.location.pathname,
        navCollapsed: state.width < TAB_SIZE ? false : state.navCollapsed
      }
    }
    
    case WINDOW_WIDTH: {
      const isCurrentlyMobile = state.width < TAB_SIZE;
      const isBecomingMobile = action.width < TAB_SIZE;
      
      return {
        ...state,
        width: action.width,
        navCollapsed: (!isCurrentlyMobile && isBecomingMobile && state.navCollapsed) 
          ? false 
          : state.navCollapsed
      };
    }

    case TOGGLE_COLLAPSED_NAV: {
      return {
        ...state,
        navCollapsed: action.navCollapsed
      }
    }

    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }

    case FETCH_SUCCESS: {
      return {...state, error: '', message: '', loading: false};
    }

    case SHOW_MESSAGE: {
      return {...state, error: '', message: action.payload, loading: false};
    }

    case FETCH_ERROR: {
      return {...state, loading: false, error: action.payload, message: ''};
    }

    case HIDE_MESSAGE: {
      return {...state, loading: false, error: '', message: ''};
    }

    case SET_FAV_ICON : {
      return {...state, favicon : action.payload, loading: false}
    }

    case SET_LOGO : {
      return {...state, logo : action.payload, loading: false}
    }
    
    case IS_PASSWORD_CHANGE:{
      return{...state,isPassword:action.payload}
    }
    
    default:
      return state;
  }
}
export default reducer;